import { useTranslation } from '@frontend/i18n';
import { shell } from '@frontend/shell-utils';
import { theme } from '@frontend/theme';
import { Modal, ModalControlModalProps, Text, Button } from '@frontend/design-system';

export const SwitchToLargeModal = (modalProps: ModalControlModalProps) => {
  const { t } = useTranslation('phone');

  return (
    <Modal {...modalProps} maxWidth={360}>
      <Modal.Header onClose={modalProps.onClose}>{t('Calendar View Unsupported')}</Modal.Header>
      <Modal.Body>
        {shell?.invoke ? (
          <Text>
            {t(
              "The Calendar View of Phone Hours isn't supported in small screen mode. To see your Phone Hours in a visual representation, please switch to a larger screen size."
            )}
          </Text>
        ) : (
          <Text>
            {t(
              "The Calendar View of Phone Hours isn't supported in small screen mode. To see your Phone Hours in a visual representation, please expand your browser window."
            )}
          </Text>
        )}
      </Modal.Body>
      {shell?.invoke && (
        <Modal.Footer>
          <Button
            variant='primary'
            size='large'
            css={{ width: theme.spacing(24), marginLeft: 'auto' }}
            onClick={() => {
              modalProps.onClose();
              shell?.invoke?.('main:update-options', { width: 1500 });
            }}
          >
            {t('Switch to Large Mode')}
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  );
};
